module.exports = __webpack_public_path__ + "static/media/napoleon-1.ceebdfb9.png";